import { io } from 'socket.io-client';

import type { Socket } from 'socket.io-client';
import type {
  ClientToServerEvents,
  ServerToClientEvents,
  WebSocketFactory,
} from '../types/network.types';

export const createWebSocket = (args: {
  wsUrl: string;
  jwt: string;
}): Socket<ServerToClientEvents, ClientToServerEvents> =>
  io(args.wsUrl, {
    path: '/ws/',
    reconnection: true,
    reconnectionAttempts: 1,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    transports: ['websocket'],
    upgrade: false,
    auth: { token: `bearer ${args.jwt}` },
  });

export const getWebSocketFactory = (): WebSocketFactory => {
  if (typeof window !== 'undefined' && (window as any).__setWebSocketFactory) {
    return (window as any).__setWebSocketFactory;
  }

  return createWebSocket;
};
